"use client";
import React, { useState } from "react";
import { handleLogin } from "../../utils/auth";

export default function LoginForm() {
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError("");
    setLoading(true);
    try {
      const formData = new FormData(event.target as HTMLFormElement);
      const result = await handleLogin(formData);
      if (result && result.status !== 200) {
        setError(result.message || "Inloggen mislukt. Probeer opnieuw.");
      }
      //eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      setError("Er is een onverwachte fout opgetreden.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center bg-primary_200 rounded-2xl bg-opacity-90">
      <div className=" p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6">Inloggen</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              className="block text-gray-500 text-sm font-bold mb-2"
              htmlFor="email"
            >
              Username of emailadres
            </label>
            <input
              type="text"
              id="username"
              name="username"
              className="inputfield"
              required
            />
          </div>
          <div className="mb-6">
            <label
              className="block text-gray-500 text-sm font-bold mb-2"
              htmlFor="password"
            >
              Wachtwoord
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className="inputfield"
              required
            />
          </div>
          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="button button-secondary"
              disabled={loading}
            >
              {loading ? "Bezig..." : "Inloggen"}
            </button>
          </div>
          
          <div className="text-center mt-4">
            <a
              href="/auth/forgot-password"
              className="text-secondary_600 hover:text-secondary_500 text-sm"
            >
              Wachtwoord vergeten?
            </a>
          </div>
          
          {error && <p className="text-red-700 mt-2">{error}</p>}
        </form>
      </div>
    </div>
  );
}
